import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Skeleton from "@mui/material/Skeleton";
import { FilterIcon } from "../../SvgIconsData";
import FilterSearch from "./FilterSearch";
import { SideArrow } from "../../assets/icons/iconshere";
import { findAllCategoryIds, findCategoryOption, searchCategory } from "../../utils";

const Filter = ({
  selectedCheckboxes,
  setSelectedCheckboxes,
  filterOptions,
  categoryOptions=null,
  selectedCategoryCheckboxes=[],
  setSelectedCategoryCheckboxes=[],
}) => {
  const configData = useSelector((state) => state.configSlice);
  const [showfilter, setShowFilter] = useState(false);
  const [sortingOpen, setSortingOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentTab, setCurrentTab] = useState(null);
  const [categoryList, setCategoryList] = useState(null);

  useEffect(() => {
    setCategoryList(categoryOptions || null);
  }, [categoryOptions]);

  const handleCheckboxChange = (event, item) => {
    const { checked } = event.target;

    if (checked) {
      setSelectedCheckboxes((prevSelected) => [...prevSelected, item]);
    } else {
      setSelectedCheckboxes((prevSelected) => prevSelected.filter((selectedItem) => selectedItem !== item));
    }
  };

  const isChecked = (item) => {
    return selectedCheckboxes.includes(item);
  };

  const body = document.body;

  const openFilter = () => {
    setShowFilter(!showfilter);
    if (!showfilter) {
      body.classList.add("filter-active");
    } else {
      body.classList.remove("filter-active");
    }
  };

  const openSorting = () => {
    setSortingOpen(!sortingOpen);
  };

  const handleReset = () => {
    setSelectedCheckboxes([]);
    selectedCategoryCheckboxes.length > 0 && setSelectedCategoryCheckboxes([]);
    setSearchQuery("");
  };

  const getSelectedCount = (filterId) => {
    const selectedCount = selectedCheckboxes.filter((item) => {
      const filter = filterOptions.find((filter) => filter.id === filterId);
      return filter.tags.some((tag) => tag.id === item.id);
    }).length;

    return selectedCount > 9 ? "9+" : selectedCount.toString();
  };

  const renderCount = (filterId) => {
    const count = getSelectedCount(filterId);
    return count !== "0" ? <span className="count">{count}</span> : null;
  };

  const toggleExpand = (item) => {
    let find = categoryList.children.find((e) => e.id == item.id);
    setCategoryList(find || null);
  };

  const handleBackCategory = (id) => {
    const result = searchCategory(id, categoryOptions);
    setCategoryList(result || null);
  };


  const handleSelectCategory = (e, category, isChecked) => {
    e.stopPropagation();
    let selectedIds= [...selectedCategoryCheckboxes]; 
    let findCategory = findCategoryOption(categoryOptions, category.id);
    let allChildrenCategoryIds = findAllCategoryIds(findCategory);

    const updateIds = (oldIds, newIds, addNewIds) => {
      const existingIds = new Set(oldIds.map(item => item.id));

      if (addNewIds) {
          const uniqueNewIds = newIds.filter(item => !existingIds.has(item.id));
          return [...oldIds, ...uniqueNewIds];
      } else {
          const filteredOldIds = oldIds.filter(item => !newIds.some(newItem => newItem.id === item.id));
          return filteredOldIds;
      }
  };
  
    let allIdsList = updateIds(selectedIds, allChildrenCategoryIds, !isChecked);
    setSelectedCategoryCheckboxes([...allIdsList]);

    // setSelectedCategoryCheckboxes((prev) => {
    //   const exists = prev.some((e) => e.id === category.id);
    //   if (exists) {
    //     return prev.filter((e) => e.id !== category.id);
    //   } else {
    //     return [...prev, category];
    //   }
    // });

  };

  console.log("2c731c4c-1c9b-42d4-96ac-04d9c9fd8188 2c731c4c-1c9b-42d4-96ac-04d9c9fd8188");
  console.log(categoryList);

  return (
    <>
      <div className="filteroption">
        <span onClick={openFilter}>
          <FilterIcon />
          Filter
          {selectedCheckboxes.length ? <span className="numberhere">{selectedCheckboxes.length}</span> : null}
        </span>
      </div>

      <div className={showfilter ? "filterbox p-4" : "filterbox inactive p-4"}>
        <div className="filterhead pt-2 pb-3">
          <p>Filter</p>
          <button onClick={handleReset}>Reset</button>
        </div>

        {categoryOptions &&
        <div className={`createdfilter ${currentTab == "categoryOpen" ? "createdactive" : ""}`}>
          <div className="createrhead" onClick={() => setCurrentTab((pre) => (pre == "categoryOpen" ? null : "categoryOpen"))}>
            <span className="d-flex align-items-center justify-content-start gap-2">
              <p className="d-flex align-items-center justify-content-start">
                <span
                  className="prev"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleBackCategory(categoryList.parentId);
                  }}
                >
                  {categoryList?.id != 229 && <SideArrow />}
                </span>

                <span className="d-flex align-items-center justify-content-start gap-2">
                  {categoryList?.name || "Categories"}
                  {selectedCategoryCheckboxes.length > 0 && (
                    <span className="count"> {selectedCategoryCheckboxes.length} </span>
                  )}
                </span>
              </p>
            </span>
            <p>
              {currentTab == "categoryOpen" ? <RemoveOutlinedIcon /> : <AddOutlinedIcon />}{" "}
            </p>
          </div>

          {currentTab == "categoryOpen" && (
            <>
              <FilterSearch placeholder="Search..." setSearchQuery={setSearchQuery} searchQuery={searchQuery} />
              <div className="createdatahere">
                {categoryList &&
                  categoryList?.children?.map((item, index) => {
                    if (searchQuery.length && !item.name.toLowerCase().includes(searchQuery)) return null;
                    const isChecked = selectedCategoryCheckboxes.some((checkbox) => checkbox.id === item.id);
                    return (
                      <div className="data-item" onClick={() => toggleExpand(item)}>
                        <div className="check-name">
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={isChecked}
                                  onClick={(e) => handleSelectCategory(e, {id: item.id, name: item.name}, isChecked)}
                                />
                              }
                            />
                          </FormGroup>
                          <p
                            onClick={() => {
                              item.children?.length > 0 && toggleExpand(item);
                            }}
                          >
                            {" "}
                            {item.name}{" "}
                          </p>
                        </div>

                        {item.children?.length > 0 && (
                          <span className="next">
                            <SideArrow />
                          </span>
                        )}
                      </div>
                    );
                  })}
              </div>
            </>
          )}
        </div>
        }

        {filterOptions.map((filter, index) => (
          <div key={index} className={`createdfilter ${currentTab == filter.id ? "createdactive" : ""}`}>
            <div className="createrhead" onClick={() => setCurrentTab(currentTab == filter.id ? null : filter.id)}>
              <span className="d-flex align-items-center justify-content-start gap-2">
                <p>{filter.name}</p>
                {renderCount(filter.id)}
              </span>
              <p>{currentTab == filter.id ? <RemoveOutlinedIcon /> : <AddOutlinedIcon />}</p>
            </div>

            {currentTab == filter.id ? (
              <>
                <FilterSearch placeholder="Search ..." setSearchQuery={setSearchQuery} searchQuery={searchQuery} />
                <div className="createdatahere mt-0 pe-2">
                  <FormGroup>
                    {filter.tags
                      .filter((item) => item.name.toLowerCase().includes(searchQuery.toLowerCase()))
                      .map((item, subIndex) => (
                        <FormControlLabel
                          key={subIndex}
                          control={
                            <Checkbox
                              onChange={(event) => handleCheckboxChange(event, item)}
                              checked={isChecked(item)}
                            />
                          }
                          label={item.name}
                        />
                      ))}
                  </FormGroup>
                </div>
              </>
            ) : null}
          </div>
        ))}
      </div>

      {showfilter && <div className="showoverlay" onClick={openFilter}></div>}
      {sortingOpen && <div className="showoverlay" onClick={openSorting}></div>}
    </>
  );
};

export default Filter;
